import React from "react";

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_8030"
            data-name="Rechteck 8030"
            width="30"
            height="30"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="Gruppe_8143" data-name="Gruppe 8143" transform="translate(0 0)">
        <g
          id="Gruppe_8142"
          data-name="Gruppe 8142"
          transform="translate(0 0.001)"
          clip-path="url(#clip-path)"
        >
          <path
            id="Pfad_7812"
            data-name="Pfad 7812"
            d="M26.38,28.242a4.142,4.142,0,0,0-3.938-3.513,3.514,3.514,0,0,0-3.615-1.714,16.876,16.876,0,0,1-.29-2.008,26.2,26.2,0,0,0,2.85-.387c1.528-.306,3.281-.821,3.281-2.1,0-1.244-1.695-1.708-2.333-1.883a21.267,21.267,0,0,0-3.485-.581l.265-1.325a7.912,7.912,0,0,0,.984-.711,5.286,5.286,0,0,0,1.053.105,5.221,5.221,0,0,0,2.814-.812A3.517,3.517,0,1,0,25.9,6.547a5.317,5.317,0,0,0-1.016-1.428,5.236,5.236,0,0,0-3.29-1.525,7.842,7.842,0,0,0-13.183,0A5.276,5.276,0,0,0,3.758,7.46,3.517,3.517,0,0,0,6.9,13.751a5.294,5.294,0,0,0,3,.265,7.877,7.877,0,0,0,.984.711l.265,1.325a21.192,21.192,0,0,0-3.485.581c-.638.175-2.333.639-2.333,1.883,0,1.284,1.753,1.8,3.28,2.1a26.235,26.235,0,0,0,2.85.387,16.777,16.777,0,0,1-.29,2.008,3.561,3.561,0,0,0-.568-.046,3.524,3.524,0,0,0-3.047,1.76A4.141,4.141,0,0,0,3.62,28.242H0V30H30V28.242Zm-3.918-9.727A10.668,10.668,0,0,1,20.487,19c-.609.1-1.286.185-2.006.249.01-.486.041-.972.092-1.456a15.74,15.74,0,0,1,3.889.724m-11.715-6.1-.373-.357a4.565,4.565,0,0,1-1.527.305,4.048,4.048,0,0,1-2.071-.625,2.283,2.283,0,0,1-1.445.625,1.758,1.758,0,0,1-.544-3.43l.5-.164A3.884,3.884,0,0,1,6.362,6.362a3.515,3.515,0,0,1,4.972,0l1.243-1.243a5.253,5.253,0,0,0-2.128-1.3,6.05,6.05,0,0,1,9.1,0,5.253,5.253,0,0,0-2.128,1.3l1.243,1.243a3.515,3.515,0,0,1,4.972,0,4.2,4.2,0,0,1,1,1.779l.544.057A1.758,1.758,0,0,1,25,11.7a2.6,2.6,0,0,1-1.259-.414,3.856,3.856,0,0,1-2.587,1.073,4.575,4.575,0,0,1-1.527-.305l-.373.357a6.153,6.153,0,0,1-8.506,0m3.374,5.222v1.748c-.283-.006-.565-.014-.842-.026a19.029,19.029,0,0,0-.43-3.776,7.962,7.962,0,0,0,4.3,0,18.942,18.942,0,0,0-.43,3.776q-.417.017-.842.026V17.637ZM9.513,19a10.657,10.657,0,0,1-1.975-.483,15.74,15.74,0,0,1,3.889-.724c.052.483.082.969.092,1.456-.72-.064-1.4-.147-2.006-.249m-4.1,9.244a2.381,2.381,0,0,1,2.295-1.758H8.74l.207-.586a1.759,1.759,0,0,1,3.316,0l1.657-.586a3.508,3.508,0,0,0-1.109-1.564,18.56,18.56,0,0,0,.406-2.632q.446.018.9.027v1.825h1.758V21.144q.457-.009.9-.027a18.629,18.629,0,0,0,.405,2.632,3.506,3.506,0,0,0-1.108,1.564l1.657.586a1.759,1.759,0,0,1,3.316,0l.207.586h1.032a2.381,2.381,0,0,1,2.295,1.758Z"
            transform="translate(0 0)"
            fill="#fff"
          />
          <rect
            id="Rechteck_8028"
            data-name="Rechteck 8028"
            width="1.758"
            height="1.758"
            transform="translate(26.426 22.969)"
            fill="#fff"
          />
          <rect
            id="Rechteck_8029"
            data-name="Rechteck 8029"
            width="1.758"
            height="1.758"
            transform="translate(1.817 24.726)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
